export default {
  namespaced: true,

  state: {
    markets: {
      items: [],
      firstLoad: true,
      menuCollapsed: false
    },
    retailers: {
      items: [],
      firstLoad: true,
      menuCollapsed: false
    },
    firstLoad: true,
    columnBackup: null
  },

  getters: {
    markets: state => state.markets.items,
    marketsFirstLoad: state => state.markets.firstLoad,
    marketsMenuCollapsed: state => state.markets.menuCollapsed,

    retailers: state => state.retailers.items,
    retailersFirstLoad: state => state.retailers.firstLoad,
    retailersMenuCollapsed: state => state.retailers.menuCollapsed,

    columnBackup: state => state.columnBackup,
    firstLoad: state => state.firstLoad,
  },

  mutations: {
    SET_MARKETS(state, value) {
      state.markets.items = value;
      if (value.length > 0) {
        state.markets.firstLoad = false;
      }
    },

    SET_COLUMN_BACKUP(state, value) {
      state.columnBackup = value;
      if (value.length > 0) {
        state.firstLoad = false;
      }
    },

    SET_MARKETS_MENU_COLLAPSED(state, value) {
      state.markets.menuCollapsed = value;
    },

    SET_RETAILERS(state, value) {
      state.retailers.items = value;
      if (value.length > 0) {
        state.retailers.firstLoad = false;
      }
    },

    SET_RETAILERS_MENU_COLLAPSED(state, value) {
      state.retailers.menuCollapsed = value;
    },
  },

  actions: {
    setMarkets({ commit }, value) {
      commit('SET_MARKETS', value);
    },

    setColumnBackup({ commit }, value) {
      commit('SET_COLUMN_BACKUP', value);
    },

    setMarketsMenuCollapsed({ commit }, value) {
      commit('SET_MARKETS_MENU_COLLAPSED', value);
    },

    setRetailers({ commit }, value) {
      commit('SET_RETAILERS', value);
    },

    setRetailersMenuCollapsed({ commit }, value) {
      commit('SET_RETAILERS_MENU_COLLAPSED', value);
    },
  },
};
